import { IAggregate } from '../Aggregate/types';

export interface IValveVar extends IAggregate {
    setPosition: number;
    actPosition: number;
}

export const schema = 'AutomationApps.Devices.Valves.ValveVar';